import { CommApiInstance } from "Utils/CommApiInstance";


const EmlAddrDupChkApi = async (
    chkVal:string,
    ReCaptchaToken:string
) => {
    return await CommApiInstance.post(`comm/eml_addr/dup_chk`,{
        apiBody: {
            chkVal:chkVal,
            cptchTkn:ReCaptchaToken,
        }
    })
    .then((Resp) => Resp.data);
}

export default EmlAddrDupChkApi;